import type { FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

/** loading展示 */
export const SearchLoading: FC<{}> = () => {
  const { t } = useAppTranslation();
  return (
    <div className="text-t2 text-grey4 flex justify-center w-full h-10 items-center">
      {t('bitable.list.searching')}
    </div>
  );
};
